import * as yup from 'yup';

export const registerValidations = () => {
    yup.addMethod(yup.object, 'uniqueProperty', function(propertyName, message) {
        return this.test('unique', message, function(value) {
            if (!value || !value[propertyName]) {
                return true;
            }

            if (
                this.parent
                    .filter((v: any) => v !== value)
                    .some((v: any) => v[propertyName] === value[propertyName])
            ) {
                throw this.createError({
                    path: `${this.path}.${propertyName}`,
                    message: `${message}${value[propertyName]}`,
                });
            }

            return true;
        });
    });
};
registerValidations();
